module.exports = __webpack_public_path__ + "static/media/submit-documentation.d80bebf4.mp3";